// extracted by mini-css-extract-plugin
export default {"storyDetailAdvertAvatar":"c-r_ho","storyDetailAdvertAvatar__image":"c-r_hp"};